import type { DynamicToolUIPart, ToolUIPart } from 'ai'
import ReactMarkdown from 'react-markdown'
import { REMARK_PLUGINS } from './markdown'
import { answerText, questionStatus, readAnswers, readAskInput } from './ask-user'

// 一組提問在對話區留下的紀錄（#1653）：開場白畫成一則一般的 AI 訊息，
// 已回答接答案摘要卡、已略過接一行說明。作答在輸入框上方的面板，不在這裡。

type AnyToolPart = ToolUIPart | DynamicToolUIPart

/** 已略過（關閉或直接回覆）時對話區留的那一行 */
export const DISMISSED_TEXT = '已略過這組提問'

export function QuestionRecord({ part }: { part: AnyToolPart }) {
  const status = questionStatus(part)
  const { preamble } = readAskInput(part.input)
  const answers = status === 'answered' ? readAnswers(part.output) : []
  return (
    <>
      {/* 🔴 與模型平常的回話同一套樣式：使用者讀到的是「AI 說了一句話」 */}
      {preamble.trim() && (
        <div className="row assistant">
          <div className="bubble">
            <div className="markdown">
              <ReactMarkdown remarkPlugins={REMARK_PLUGINS}>{preamble}</ReactMarkdown>
            </div>
          </div>
        </div>
      )}
      {/* 🔴 包在與 AI 訊息同一個 .row.assistant 裡，左右邊界才與開場白、回覆對齊 */}
      {answers.length > 0 && (
        <div className="row assistant">
          <dl className="answer-summary" aria-label="你的回答">
            {answers.map((item, index) => (
              <div key={index} className="answer-summary-item">
                <dt>{item.question}</dt>
                <dd className={item.skipped ? 'skipped' : ''}>{answerText(item)}</dd>
              </div>
            ))}
          </dl>
        </div>
      )}
      {status === 'unanswered' && (
        <div className="row assistant">
          <span className="question-dismissed">{DISMISSED_TEXT}</span>
        </div>
      )}
    </>
  )
}
